import React, { useState } from 'react';
import '../../../entrydoor.css';

const HardwareFinish = ({ value, onChange, label = 'Hardware Finish:', disabled = false }) => {
    const [selectedHardwareFinish, setSelectedHardwareFinish] = useState(value || "White");

    const handleHardwareFinishChange = (e) => {
        setSelectedHardwareFinish(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="HardwareFinish">{label}</label>
            <select
                disabled={disabled}
                id="HardwareFinish"
                value={selectedHardwareFinish}
                onChange={handleHardwareFinishChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="White">{selectedHardwareFinish === "White" ? "White ✔" : "White"}</option>
                <option value="Black">{selectedHardwareFinish === "Black" ? "Black ✔" : "Black"}</option>
                <option value="Titan">{selectedHardwareFinish === "Titan" ? "Titan ✔" : "Titan"}</option>
                <option value="Brown">{selectedHardwareFinish === "Brown" ? "Brown ✔" : "Brown"}</option>
                <option value="Gold">{selectedHardwareFinish === "Gold" ? "Gold ✔" : "Gold"}</option>
            </select>
        </div>
    );
};

export default HardwareFinish;
